import styled from 'styled-components';

import bkImg from 'ui/assets/img/bg-partner-definitive.webp';

export const CurtainWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  margin: auto;
  justify-content: center;
  align-items: center;
  display: flex;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(196, 196, 196, 0.2);
  z-index: 9999;
`;

export const Blur = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(${bkImg});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;
  // filter: blur(25px);
  opacity: 0.18;
`;
